import validate from "/disk2/server/proxy-front-ssr/dists/sx/node_modules/nuxt/dist/pages/runtime/validate.js";
import cache_45headers_45global from "/disk2/server/proxy-front-ssr/dists/sx/middleware/cache-headers.global.ts";
import check_45auth_45global from "/disk2/server/proxy-front-ssr/dists/sx/middleware/checkAuth.global.ts";
import check_45local_45global from "/disk2/server/proxy-front-ssr/dists/sx/middleware/checkLocal.global.ts";
import cookie_45control_45global from "/disk2/server/proxy-front-ssr/dists/sx/middleware/cookie-control.global.ts";
import trailing_45slash_45global from "/disk2/server/proxy-front-ssr/dists/sx/middleware/trailingSlash.global.ts";
import manifest_45route_45rule from "/disk2/server/proxy-front-ssr/dists/sx/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  cache_45headers_45global,
  check_45auth_45global,
  check_45local_45global,
  cookie_45control_45global,
  trailing_45slash_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "check-black-proxy-component": () => import("/disk2/server/proxy-front-ssr/dists/sx/middleware/checkBlackProxyComponent.ts"),
  "check-geo-and-compare-component": () => import("/disk2/server/proxy-front-ssr/dists/sx/middleware/checkGeoAndCompareComponent.ts"),
  "check-partner-component": () => import("/disk2/server/proxy-front-ssr/dists/sx/middleware/checkPartnerComponent.ts"),
  "check-redirect": () => import("/disk2/server/proxy-front-ssr/dists/sx/middleware/checkRedirect.ts"),
  "i18n-links": () => import("/disk2/server/proxy-front-ssr/dists/sx/middleware/i18nLinks.ts"),
  "redirect-proxy": () => import("/disk2/server/proxy-front-ssr/dists/sx/middleware/redirectProxy.ts")
}